import { render } from "./ContractObjectModal.vue?vue&type=template&id=b1123fca&scoped=true"
import script from "./ContractObjectModal.vue?vue&type=script&lang=js"
export * from "./ContractObjectModal.vue?vue&type=script&lang=js"

import "./ContractObjectModal.vue?vue&type=style&index=0&id=b1123fca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1123fca"]])

export default __exports__